import { createFileRoute } from "@tanstack/react-router";
import { PreviewStage } from "@/external/tasting/PreviewStage";
import { signalPreviewReady } from "@/external/tasting/preview-room";

/** The host's stage in a tasting's preview, framed by the editor's preview dialog beside the tablet. */
export const Route = createFileRoute("/stage/preview-stage")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): { room?: string } => ({
    room: typeof search.room === "string" ? search.room : undefined,
  }),
});

function RouteComponent() {
  const { room } = Route.useSearch();
  return (
    <>
      <PreviewStage room={room ?? "tasting-preview"} />
      <span hidden ref={signalPreviewReady} />
    </>
  );
}
